"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
const style_1 = require("./style");
function SystemProductList({ productsList }) {
    return (react_1.default.createElement(style_1.ProductList, null, !productsList ? (react_1.default.createElement(ProductLoader, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
        productsList.length === 0 && (react_1.default.createElement(style_1.NoProductsFoundWrapper, null,
            react_1.default.createElement(style_1.NoProductsFound, { variant: "h5" }, "No products found"))),
        productsList?.map((product, i) => (react_1.default.createElement("span", { key: `${product}-${i}` },
            react_1.default.createElement(style_1.ListItem, { key: i }, product),
            react_1.default.createElement(style_1.Divider, { key: product }))))))));
}
exports.default = SystemProductList;
const ProductLoader = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Skeleton_1.default, null),
        react_1.default.createElement(Skeleton_1.default, null),
        react_1.default.createElement(Skeleton_1.default, null)));
};
